import { render, staticRenderFns } from "./AutocompleteCity.vue?vue&type=template&id=90fd9210"
import script from "./AutocompleteCity.vue?vue&type=script&lang=js"
export * from "./AutocompleteCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports